// extracted by mini-css-extract-plugin
export var label = "_b7-5";
export var slideContainer = "_b7-0";
export var slider = "_b7-1";
export var sliderLg = "_b7-4";
export var sliderMd = "_b7-3";
export var sliderSm = "_b7-2";